import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { reduxForm, Field } from 'redux-form/immutable';
import { Api } from '../api';

import { Select, Input as SimpleInput } from '../field-components';
import messages from '../messages';
import { required, validateEmail, validatePhone } from '../validators';

const btnStyles = {
  background: '#ff862c',
  color: '#fff',
  padding: '10px 56px',
  border: 'none',
  borderRadius: '8px',
  fontSize: 16,
  display: 'flex',
  margin: '20px 0px 0px auto',
};

const styles = {
  display: 'block',
  border: 'none',
  outline: 'none',
  background: 'none',
  borderBottom: '1px solid #ccc',
  opacity: '0.7',
  width: '100%',
  height: 30,
  // marginTop: 10,
};

class Feedback extends Component {
  state = {
    currentRegion: null,
    districts: [],
  };

  componentDidMount() {
    const { formConfig, formStates, districts, initialize } = this.props;
    if (formStates[formConfig.form].values) {
      const values = formStates[formConfig.form].values[formConfig.formName];
      const fullname = `${values.last_name || ''} ${values.first_name || ''} ${values.middle_name || ''}`;
      values.full_name = fullname;
      values.phone_number = '+998';
      values.description = '';
      if (values.region_id) this.setState({ districts, currentRegion: values.region_id });
      initialize(values);
    }
  }

  updateDistricts = (e) => {
    const regionId = e.target.value;
    Api.fetchDistricts(regionId).then((resp) => {
      this.setState({ districts: JSON.parse(resp.body), currentRegion: regionId });
    });
  };

  render() {
    const { districts } = this.state;
    const { handleSubmit, regions, captchaUrl, updateCaptcha } = this.props;
    return (
      <div onSubmit={(e) => e.stopPropagation()}>
        <form onSubmit={handleSubmit} style={{ width: '95%', margin: '0 auto' }} noValidate>
          <Field
            component={SimpleInput}
            name="full_name"
            validate={[required]}
            label={<FormattedMessage {...messages.full_name} />}
            className="mb-1"
            forceEdit={true}
            noRow
          />
          <Field
            component={SimpleInput}
            name="phone_number"
            validate={[validatePhone]}
            label={<FormattedMessage {...messages.phone} />}
            className="mb-1"
            forceEdit={true}
            noRow
          />
          <Field
            component={SimpleInput}
            type="email"
            name="email"
            validate={[validateEmail]}
            label={<FormattedMessage {...messages.feedback_email} />}
            className="mb-1"
            forceEdit={true}
            noRow
          />

          <div className="mt-2">
            <label className="mr-1">
              <FormattedMessage {...messages.region} />
            </label>
            <Field
              name="region_id"
              type="text"
              component={Select}
              style={styles}
              validate={[required]}
              onChange={this.updateDistricts}>
              <option />
              {regions.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.title}
                </option>
              ))}
            </Field>
          </div>

          <div className="mt-2">
            <label>
              <FormattedMessage {...messages.district} />
            </label>
            <Field name="district_id" type="text" component={Select} validate={[required]} style={styles}>
              <option />
              {districts.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.title}
                </option>
              ))}
            </Field>
          </div>

          <Field
            component={SimpleInput}
            name="description"
            validate={[required]}
            label={<FormattedMessage {...messages.makhalla} />}
            className="mt-2 mb-2"
            forceEdit={true}
            noRow
          />

          <label>
            <FormattedMessage {...messages.captcha} />
          </label>
          <div className="mt-1" style={{ display: 'flex' }}>
            <img src={captchaUrl} style={{ height: '100%', cursor: 'pointer' }} alt="captcha" onClick={updateCaptcha} />
            <Field component={SimpleInput} name="verify_code" validate={[required]} />
          </div>

          <button className="" style={btnStyles} type="submit">
            <FormattedMessage {...messages.sendButton} />
          </button>
        </form>
      </div>
    );
  }
}

Feedback = reduxForm({ form: 'feedback' })(Feedback);

const mapStateToProps = (state) => ({ formStates: state.get('form').toJS() });
export default connect(mapStateToProps, null)(Feedback);



// WEBPACK FOOTER //
// ./src/application-form/forms/feedback.js